/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Oct 15 2024
 **/

import { useTheme } from "@emotion/react";

import { Icon, Typography } from "@/frameworks/designStuff/components";
import { Choice } from "@/frameworks/libraries/components";
import { _T } from "@rfice/language";

import * as S from "../../emotion";
import { VoteType } from "./Vote";
import { MessageList } from "@/frameworks/core/chat";
import { useChatRoomActions } from "@/frameworks/core/chat";

type TransparentVote = {
	vote: MessageList[string]["vote"];
	roomID: string;
	spaceID?: string;
	voteType: VoteType;
};

export default function TransparentVote({ vote, roomID, spaceID, voteType }: TransparentVote) {
	const chatRoomActions = useChatRoomActions();
	const { colors } = useTheme();

	const handleClick = () => {
		chatRoomActions.common.open(
			spaceID ? { channelID: roomID, type: "Space", spaceID: String(spaceID) } : { channelID: roomID, type: "DM" }
		);
	};

	return (
		<S.VoteWrapper>
			<S.TitleWrapper verticalAlign="center">
				<Typography.p typoSize="Body2" typoColor="neutral_70_100">
					<Choice value={voteType}>
						<Choice.Case test="create">{_T("투표가 시작되었습니다.")}</Choice.Case>
						<Choice.Case test="end">{_T("투표가 종료되었습니다.")}</Choice.Case>
						<Choice.Case test="remind">{_T("투표종료 30분전입니다.")}</Choice.Case>
					</Choice>
				</Typography.p>
			</S.TitleWrapper>
			<S.TransparentVoteContent verticalAlign="center" gap={12} onClick={handleClick}>
				<S.IconBox>
					<Icon name="Vote24" size={20} fill={colors.neutral_00_100} />
				</S.IconBox>
				<S.TransparentVoteBox>
					<Typography.p typoSize="Body3_MD" typoColor="neutral_80_100">
						{vote?.title}
					</Typography.p>
					<Typography.p typoSize="Body4" typoColor="neutral_60_100">
						{_T("투표하러 가기")}
					</Typography.p>
				</S.TransparentVoteBox>
			</S.TransparentVoteContent>
		</S.VoteWrapper>
	);
}
